import React from 'react';
import { IMaskInput } from 'react-imask';

type CustomIMaskInputProps = {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
};

export const CustomIMaskInput = React.forwardRef<HTMLInputElement, CustomIMaskInputProps>(
  function CustomIMaskInput(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="(#00) 000-0000"
        definitions={{
          '#': /[1-9]/,
        }}
        inputRef={ref}
        onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    );
  },
);
